import React from 'react';
import { Phone, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { Participant } from '../../../context/LeadAttendanceContext';

interface MemberListTabProps {
  participants: Participant[];
  isLoadingParticipants: boolean;
}

export default function MemberListTab({ participants, isLoadingParticipants }: MemberListTabProps) {
  const { t } = useTranslation();
  return (
    <section className="space-y-3">
      <header className="flex items-center justify-between rounded-2xl border border-slate-200 bg-slate-50 p-3">
        <h3 className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-slate-500">
          <Users className="h-4 w-4" />
          {t('membersTitle')}
        </h3>
        <span className="text-xs text-slate-500">{participants.length} {t('registeredCount')}</span>
      </header>

      {isLoadingParticipants && (
        <div className="space-y-2">
          {Array.from({ length: 6 }).map((_, idx) => (
            <div key={idx} className="h-14 animate-pulse rounded-xl bg-slate-100" />
          ))}
        </div>
      )}

      {!isLoadingParticipants && participants.length === 0 && (
        <p className="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-4 text-sm text-slate-500">
          {t('noParticipants')}
        </p>
      )}

      <ul className="space-y-2">
        {participants.map((participant) => (
          <li key={participant.id} className="flex items-center justify-between rounded-xl border border-slate-200 bg-white px-3 py-3">
            <div>
              <p className="font-medium text-slate-900">{participant.name}</p>
              <p className="text-xs text-slate-500">ID: {participant.id}</p>
            </div>
            <span className="inline-flex items-center gap-1 text-xs text-slate-600">
              <Phone className="h-3.5 w-3.5" />
              {participant.phone || t('noPhone')}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
